import React from "react";

export const PlanProBadge = (
  <a
    className="inline-block text-white font-medium rounded-lg text-sm py-0.5 px-2 bg-slate-500 text-center ml-3"
    title="Upgrade to a Professional plan to activate this feature"
    href="https://wizy.chat/pricing"
    target="_blank"
  >
    pro
  </a>
);

export const PlanHobbyBadge = (
  <a
    className="inline-block text-white font-medium rounded-lg text-sm py-0.5 px-2 bg-slate-500 text-center ml-3"
    title="Upgrade to a Hobby plan to activate this feature"
    href="https://wizy.chat/pricing"
    target="_blank"
  >
    hobby
  </a>
);
